import React, {useEffect, useRef} from "react";
import "./mainSection.scss";
import LinkSectionComponent from "../../sections/linkSection/LinkSectionComponent";
import ContactSectionComponent from "./sections/contactSection/ContactSectionComponent";
import MobileAppSectionComponent from "./sections/mobileAppSection/MobileAppSectionComponent";
import DiscoverySectionComponent from "./sections/discoverSection/DiscoverySectionComponent";
import {useLocation} from "react-router-dom";
import Navbar from "../../components/headSection/components/Navbar";
import StartSection from "./sections/startSection/StartSection";

export default function MainSectionComponent() {
    const homeRef = useRef<HTMLDivElement>(null);
    const howItWorksRef = useRef<HTMLDivElement>(null);
    //const discoveryRef = useRef<HTMLDivElement>(null);
    const mobileAppRef = useRef<HTMLDivElement>(null);
    const followUsRef = useRef<HTMLDivElement>(null);
    const scrollContainerRef = useRef<HTMLDivElement>(null);
    const location = useLocation();

    const scrollToBlock = (blockClass: string) => {
        const block = document.querySelector(`.${blockClass}`);
        if (block) {
            block.scrollIntoView({ behavior: 'smooth' });
        }
    };

    useEffect(() => {
        const path = location.pathname;
        console.log("path: ", path);
        let targetRef;
        switch (path) {
            case '/':
                targetRef = homeRef;
                scrollToBlock('headSection__container');
                break;
            /*case '/how-it-works':
                targetRef = howItWorksRef;
                scrollToBlock('linkSection__container');
                break;*/
            case '/mobile-app':
                targetRef = mobileAppRef;
                scrollToBlock('mobileAppSectionComponent__container');
                break;
            case '/follow-us':
                targetRef = followUsRef;
                scrollToBlock('contactSectionComponent__container');
                break;
            /*case '/discovery':
                targetRef = discoveryRef;
                break;*/
            default:
                targetRef = homeRef;
                scrollToBlock('headSection__container');
        }

    }, [location.pathname, homeRef, howItWorksRef, mobileAppRef, followUsRef]);

    return (
        <div className="mainSectionComponent__container" ref={scrollContainerRef}>
            <div className="mainSectionComponent__container-content-overlay"></div>
            <div className="mainSectionComponent__container-content-login"></div>
            <div className="mainSectionComponent__container-content">
                    {/* <HeadSectionComponent /> */}
                <div
                  ref={homeRef}
                  className="headSectionComponent__container"
                  style={{ background: `url(${process.env.PUBLIC_URL}/images/desktop.webp)`, backgroundSize: 'cover'}}
                >
                    <Navbar />
                    <StartSection />
                </div>
                {/*<div ref={howItWorksRef}>
                    <LinkSectionComponent />
                </div>*/}
                <DiscoverySectionComponent />
                <div ref={mobileAppRef}>
                    <MobileAppSectionComponent />
                </div>
                <div ref={followUsRef}>
                    <ContactSectionComponent />
                </div>
            </div>
        </div>
    );
}